module.exports = __webpack_public_path__ + "img/marker-koramil.48a13ffc.svg";